import { api } from "./client";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const createBrand = async (brandData) => {
  // Basic frontend validation before sending the request
  if (
    !brandData ||
    !brandData.brandName ||
    !brandData.brandName.en?.trim() ||
    !brandData.brandName.ar?.trim()
  ) {
    throw new Error("Both English and Arabic brand names are required.");
  }

  if (brandData.logo && typeof brandData.logo !== "string") {
    throw new Error("Logo must be a valid base64 string or image path.");
  }

  try {
    const response = await api.post(`${API_BASE_URL}api/brands/create`, brandData);
    return response.data;
  } catch (error) {
    // Re-throw error with custom message if needed
    const message =
      error.response?.data?.message || "Error creating brand. Please try again.";
    throw new Error(message);
  }
};

// Get Brand list
// Get Brand list
export const getAllBrands = async () => {
  const response = await api.get(`${API_BASE_URL}api/brands/list`);
  return response.data.data; // always return full brandName { en, ar }
};


// ✅ Update Brand
export const updateBrandAPI = async (id, data) => {
  try {
    const res = await api.put(`${API_BASE_URL}api/brands/update/${id}`, data);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Update failed');
  }
};

//Delete api
export const deleteBrandAPI = async (id) => {
  if (!id) throw new Error("Missing brand ID");
  const res = await api.delete(`${API_BASE_URL}api/brands/delete/${id}`);
  return res.data;
};

// get all brands list
export const getAllBrandsList = async () => {
  const lang = localStorage.getItem("lang") || "en";
  const response = await api.get(`${API_BASE_URL}api/brands/list`, {
    headers: { "Accept-Language": lang },
  });

  // Filter active brands only
  const allBrands = response.data.data || [];

  const activeBrands = allBrands.filter(
    (brand) => brand.status?.toLowerCase() === "active"
  );

  return activeBrands;
};